import { gsap, ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default () => {
  let mm = gsap.matchMedia();
  ScrollTrigger.defaults({
    toggleActions: 'restart pause resume pause',
    markers: window.location.hostname.endsWith('.local') ? true : false,
  });

  //------------------------------------------------------//
  // On browser 📜 scroll full window height
  //------------------------------------------------------//
  ScrollTrigger.create({
    id: 'Scrolled',
    trigger: 'body',
    start: `${window.innerHeight * 1.5} bottom`,
    toggleClass: 'showScrolled',
  });
  // END On browser 📜 scroll full window height
  // -------------------------------------//
  //--------------------------------//
  // Menu toggle animation
  //--------------------------------//
  // Menu toggle setup
  let tlMenuToggleAll = [];  // Collect all menu buttons;
  const menuToggle = document.querySelectorAll('.menu-toggle');
  // Animation function
  function menuToggleAnimation(target) {
    const q = gsap.utils.selector(target);
    // Menu toggle animation
    const tl = gsap.timeline({
      paused: true,
      reversed: true,
      defaults: { duration: 0.3, ease: 'power3.in' },
      onComplete: () => target.setAttribute('aria-expanded', true),
      onReverseComplete: () => target.setAttribute('aria-expanded', false),
    });
    // // ---- Simple ----
    // tl.to(q(".anim"), {rotate: gsap.utils.wrap([-45, 45])});
    // tl.to(q(".anim"), { y: 0 }, "<");
    // tl.to(q(".text"), { duration: 0.1, opacity: 0 }, "<");

    //   // ---- Spinning ----
    //   tl.to(q(".inner"), { duration: 0.8, rotate: 360 * 3 });
    //   tl.to(q(".anim"), { y: 0 }, "<");
    //   tl.to(q(".text"), { duration: 0.1, opacity: 0 }, "<");
    //   tl.to(q(".anim"), {
    //     duration: 0.45,
    //     rotate: gsap.utils.wrap([45 * 3, 45 * 5])
    //   }, "-=0.6");

    // // ---- Rotate ----
    // tl.to(q(".inner"), { rotate: -90 });
    // tl.to(q(".anim"), { y: 0 }, "<");
    // tl.to(q(".anim"), {rotate: gsap.utils.wrap([45, -45])});
    // tl.to(q(".text"), { duration: 0.1, opacity: 0 }, "<");

    // // ---- Move out in ----
    // tl.to(q(".inner span"), { xPercent: -150, stagger: 0.1 });
    //   tl.set(q(".anim"), { y: 0 });
    // tl.set(q(".anim"), {
    //   duration: 0.45,
    //   rotate: gsap.utils.wrap([45 * 3, 45 * 5])
    // });
    // tl.set(q(".text"), { opacity: 0 }, "<");
    // tl.set(q(".inner span"), { xPercent: 0 });
    // tl.set(q(".inner .anim"), { xPercent: 150 });
    // tl.to(q(".inner .anim"), { xPercent: 0 });

    // ---- Rotate animation ----
    tl.to(q('.anim'), { y: 0 });
    tl.to(q('.anim'), {
      duration: 0.45,
      rotate: gsap.utils.wrap([45 * 3, 45 * 5]),
    });
    tl.to(q('.text'), { duration: 0.1, opacity: 0 }, '<');
    tlMenuToggleAll.push(tl);  // Capture all timelines
    return tl;
  }

  function toggleAnimation(dialogId) {
    if (dialogId === 'navigation-slide') {
      tlMenuToggleAll.forEach((tl) => {
        tl.reversed() ? tl.play() : tl.reverse();
      });
    }
  }

  document.querySelectorAll('.menu-toggle').forEach((item) => {
    const q = gsap.utils.selector(item);
    const offset = item.getBoundingClientRect().height * 0.2;
    // Animate only if item is a button
    if (item.tagName === 'BUTTON') {
      gsap.set(q('.anim'), {
        y: gsap.utils.wrap([offset, -offset]),
        duration: 0.15,
        ease: 'power4.in',
      });
      gsap.set(q('.text'), { opacity: 1 });
      // Create animation
      menuToggleAnimation(item);
    }
  });
  // END Menu slide animation --------------//
  // END Menu toggle animation --------------//

  //--------------------------------//
  // Dialog logic
  //--------------------------------//
  document.querySelectorAll('.dialog-open').forEach(button => {
    button.addEventListener('click', (event) => {
      const dialogId = button.getAttribute('aria-controls');
      const dialog = document.getElementById(dialogId);

      if (dialog) {
        document.querySelector('#live-region').textContent =
          dialog.dataset.liveOpen;
        dialog.showModal();
        dialog.setAttribute('aria-expanded', true);
        toggleAnimation(dialogId);
      }
    });
  });

  document.querySelectorAll('.dialog-close').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('dialog[open]').forEach(dialog => {
        document.querySelector('#live-region').textContent =
          dialog.dataset.liveClose;
        dialog.close();
        dialog.setAttribute('aria-expanded', false);
        toggleAnimation(dialog.id);
      });
    });
  });

  // Close dialog when clicking outside of its content
  document.addEventListener('click', (event) => {
    const openDialogs = document.querySelectorAll('dialog[open]');

    openDialogs.forEach(dialog => {
      if (event.target === dialog) {
        dialog.close();
        dialog.setAttribute('aria-expanded', false);
        toggleAnimation(toggleAnimation(dialog.id));
      }
    });
  });
  // END Dialog elements --------------//

  //--------------------------------//
  // S&F toggle show hide 
  //--------------------------------//
  if (document.querySelector('.alloy-filter-slide_over-toggle')) {
    const tl = gsap.timeline({

      scrollTrigger: {
        id: 'FilterScrolled',
        trigger: '#alloy-sf-everything',
        start: `top top`,
        end: `bottom bottom`,
        toggleActions: 'play reverse play reverse',
      }
    });
    tl.from('.alloy-filter-slide_over-toggle', {
      y: 200,
    })
  }
  // END S&F toggle show hide --------------//

  //--------------------------------//
  // WooCommerce checkout: order review heading at top of #order_review
  //--------------------------------//
  if (document.body.classList.contains('woocommerce-checkout')) {
    const orderReview = document.querySelector('#order_review');
    const orderReviewHeading = document.querySelector('#order_review_heading');
    if (orderReview && orderReviewHeading) {
      orderReview.prepend(orderReviewHeading);
    }
  }
  // END WooCommerce checkout order review heading --------------//

  //--------------------------------//
  // CAO overview: search, highlight, scroll to match
  //--------------------------------//
  const caoSearchInput = document.querySelector('#cao-search');
  const caoOverview = document.querySelector('.overview-cao');
  const caoSearchNav = document.querySelector('#cao-search-nav');
  const caoSearchCountEl = caoSearchNav?.querySelector('.cao-search-nav__count');
  const caoSearchPositionEl = caoSearchNav?.querySelector('.cao-search-nav__position');
  const caoSearchPrev = document.querySelector('#cao-search-prev');
  const caoSearchNext = document.querySelector('#cao-search-next');

  if (caoSearchInput && caoOverview && caoSearchNav && caoSearchCountEl && caoSearchPositionEl && caoSearchPrev && caoSearchNext) {
    const HIGHLIGHT_CLASS = 'cao-search-highlight';
    const CURRENT_CLASS = 'cao-search-highlight--current';
    let debounceId;
    let currentMatchIndex = 0;

    function getCaoMatchMarks() {
      return caoOverview.querySelectorAll(`mark.${HIGHLIGHT_CLASS}`);
    }

    function syncCaoSearchNav() {
      const query = caoSearchInput.value.trim();
      const marks = getCaoMatchMarks();
      const total = marks.length;

      if (query.length < 2) {
        caoSearchNav.hidden = true;
        caoSearchCountEl.textContent = '';
        caoSearchPositionEl.textContent = '';
        return;
      }

      caoSearchNav.hidden = false;

      if (total === 0) {
        caoSearchCountEl.textContent = caoSearchNav.dataset.msgNone || '';
        caoSearchPositionEl.textContent = '';
        caoSearchPrev.disabled = true;
        caoSearchNext.disabled = true;
        return;
      }

      const countLabel =
        total === 1
          ? caoSearchNav.dataset.msgOne || ''
          : (caoSearchNav.dataset.msgMany || '').replace('%d', String(total));
      caoSearchCountEl.textContent = countLabel;

      const posTpl = caoSearchNav.dataset.msgPos || '';
      const displayCurrent = currentMatchIndex + 1;
      caoSearchPositionEl.textContent = posTpl
        .replace('%1$d', String(displayCurrent))
        .replace('%2$d', String(total));

      const multi = total > 1;
      caoSearchPrev.disabled = !multi;
      caoSearchNext.disabled = !multi;
    }

    function setActiveCaoMatch(index) {
      const marks = getCaoMatchMarks();
      const total = marks.length;
      if (total === 0) return;
      currentMatchIndex = ((index % total) + total) % total;
      marks.forEach((m, i) => {
        m.classList.toggle(CURRENT_CLASS, i === currentMatchIndex);
      });
      syncCaoSearchNav();
      requestAnimationFrame(() => {
        marks[currentMatchIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });
    }

    function stepActiveCaoMatch(delta) {
      setActiveCaoMatch(currentMatchIndex + delta);
    }

    function escapeRegex(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function clearCaoHighlights() {
      caoOverview.querySelectorAll(`mark.${HIGHLIGHT_CLASS}`).forEach((mark) => {
        const parent = mark.parentNode;
        if (!parent) return;
        while (mark.firstChild) {
          parent.insertBefore(mark.firstChild, mark);
        }
        parent.removeChild(mark);
      });
      caoOverview.normalize();
    }

    function collectTextNodes(root) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (!node.nodeValue || !/\S/.test(node.nodeValue)) {
            return NodeFilter.FILTER_REJECT;
          }
          let el = node.parentElement;
          while (el) {
            if (el.classList && el.classList.contains(HIGHLIGHT_CLASS)) {
              return NodeFilter.FILTER_REJECT;
            }
            const tag = el.tagName;
            if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') {
              return NodeFilter.FILTER_REJECT;
            }
            el = el.parentElement;
          }
          return NodeFilter.FILTER_ACCEPT;
        },
      });
      const list = [];
      let n;
      while ((n = walker.nextNode())) {
        list.push(n);
      }
      return list;
    }

    function highlightInTextNode(textNode, regex) {
      const text = textNode.nodeValue;
      const parent = textNode.parentNode;
      if (!parent || !regex.test(text)) {
        regex.lastIndex = 0;
        return false;
      }
      regex.lastIndex = 0;
      const frag = document.createDocumentFragment();
      let lastIndex = 0;
      let match;
      while ((match = regex.exec(text)) !== null) {
        frag.appendChild(
          document.createTextNode(text.slice(lastIndex, match.index)),
        );
        const mark = document.createElement('mark');
        mark.className = HIGHLIGHT_CLASS;
        mark.textContent = match[0];
        frag.appendChild(mark);
        lastIndex = match.index + match[0].length;
        if (lastIndex === text.length) break;
      }
      frag.appendChild(document.createTextNode(text.slice(lastIndex)));
      parent.replaceChild(frag, textNode);
      return true;
    }

    function runCaoSearch(rawQuery) {
      clearCaoHighlights();
      currentMatchIndex = 0;
      const query = rawQuery.trim();
      if (query.length < 2) {
        syncCaoSearchNav();
        return;
      }
      const regex = new RegExp(escapeRegex(query), 'gi');
      const textNodes = collectTextNodes(caoOverview);
      for (const node of textNodes) {
        if (!node.parentNode) continue;
        highlightInTextNode(node, regex);
        regex.lastIndex = 0;
      }
      const marks = getCaoMatchMarks();
      if (marks.length === 0) {
        syncCaoSearchNav();
        return;
      }
      setActiveCaoMatch(0);
    }

    caoSearchInput.addEventListener('input', () => {
      window.clearTimeout(debounceId);
      debounceId = window.setTimeout(() => {
        runCaoSearch(caoSearchInput.value);
      }, 200);
    });

    caoSearchInput.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter') {
        return;
      }
      const marks = getCaoMatchMarks();
      if (marks.length === 0) {
        return;
      }
      e.preventDefault();
      stepActiveCaoMatch(e.shiftKey ? -1 : 1);
    });

    caoSearchPrev.addEventListener('click', () => {
      if (caoSearchPrev.disabled) return;
      stepActiveCaoMatch(-1);
    });
    caoSearchNext.addEventListener('click', () => {
      if (caoSearchNext.disabled) return;
      stepActiveCaoMatch(1);
    });

    syncCaoSearchNav();
  }
  // END CAO overview search --------------//

  // CAO TOC: toggle nested ol.sub
  const caoToc = document.querySelector('#cao .toc');
  if (caoToc) {
    caoToc.addEventListener('click', (e) => {
      const toggle = e.target.closest('.toc-sub-toggle');
      if (!toggle || !caoToc.contains(toggle)) {
        return;
      }
      e.preventDefault();
      const wasExpanded = toggle.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !wasExpanded;
      if (nextExpanded) {
        caoToc.querySelectorAll('.toc-sub-toggle').forEach((other) => {
          if (other === toggle) {
            return;
          }
          other.setAttribute('aria-expanded', 'false');
          const otherPanel = other.nextElementSibling;
          if (otherPanel && otherPanel.classList.contains('toc-sub-panel')) {
            otherPanel.inert = true;
          }
        });
      }
      toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
      const panel = toggle.nextElementSibling;
      if (panel && panel.classList.contains('toc-sub-panel')) {
        panel.inert = !nextExpanded;
      }
    });
  }
  // END CAO TOC --------------//

  //--------------------------------//
  // Site notification: dismiss + remember
  //--------------------------------//
  const siteNotification = document.querySelector('.site-notification');
  if (siteNotification) {
    const STORAGE_KEY = 'alloy_site_notification_dismissed_id';
    const dismissId = siteNotification.getAttribute('data-dismiss-id') || '';

    if (dismissId && localStorage.getItem(STORAGE_KEY) === dismissId) {
      siteNotification.hidden = true;
    }

    const closeBtn = siteNotification.querySelector('.site-notification__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        if (dismissId) {
          try {
            localStorage.setItem(STORAGE_KEY, dismissId);
          } catch {
            // Private mode / quota
          }
        }
        siteNotification.hidden = true;
        const liveRegion = document.querySelector('#live-region');
        if (liveRegion) {
          liveRegion.textContent =
            siteNotification.dataset.dismissMessage || '';
        }
      });
    }
  }
  // END Site notification --------------//


};
